import { useRef as u, useEffect as i } from "react";
const o = () => {
}, d = (e, n, t) => {
  const c = (/* @__PURE__ */ new Date()).getTime(), a = () => {
    if ((/* @__PURE__ */ new Date()).getTime() - c >= n) {
      e == null || e(), t(o);
      return;
    }
    const l = requestAnimationFrame(a);
    t(() => cancelAnimationFrame(l));
  }, r = requestAnimationFrame(a);
  t(() => cancelAnimationFrame(r));
}, m = () => {
  const e = u(o), n = (c) => e.current = c, t = () => e.current();
  return i(() => t, []), [n, t];
}, f = ({
  onClick: e,
  onDoubleClick: n,
  delay: t = 300
}) => {
  const [c, a] = m();
  return [() => {
    a(), d(e, t, c);
  }, () => {
    a(), n == null || n();
  }];
};
export {
  f as default
};
